import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from 'src/app/pages/landing-page/landing-page/landing-page.component';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { ChangePasswordComponent } from 'src/app/pages/change-password/change-password.component';
import { ForgotPassComponent } from 'src/app/pages/forgot-pass/forgot-pass.component';
import { RegistroClienteComponent } from 'src/app/pages/registro-cliente/registro-cliente.component';
import { ValidacionIdentidadComponent } from 'src/app/pages/validacion-identidad/validacion-identidad.component';

export const AuthLayoutRoutes: Routes = [
    { path: 'home-page', component: LandingPageComponent },
    { path: 'login', component: LoginComponent },
    { path: 'change-password/:to', component: ChangePasswordComponent },
    { path: 'RegistroCliente/:to', component: RegistroClienteComponent },
    { path: 'forgotpass', component: ForgotPassComponent},
    { path: 'validate-identity/:to',component: ValidacionIdentidadComponent}
];
